import { createContext } from "react";

export interface IProductContextProps {
    loadProducts(): Promise<void>;
    availableProducts: string[];
    hasProduct(productName: string): boolean;
}

export const ProductContext = createContext<IProductContextProps>(null!);
